var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup1510(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1403",
    "data-name": "Rectangle 1403",
    width: 16,
    height: 16,
    transform: "translate(0 -0.105)",
    fill: "#30B524"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1510",
    "data-name": "Group 1510",
    transform: "translate(0 0.105)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1504",
    "data-name": "Group 1504",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47567",
    "data-name": "Path 47567",
    d: "M2.384,12.717H5.752a.794.794,0,0,0,.564-.23l5.5-5.506,2.256-2.209a.794.794,0,0,0,0-1.123l0,0L10.7.235a.794.794,0,0,0-1.123,0l0,0L7.334,2.484,1.819,7.99a.794.794,0,0,0-.23.564v3.369a.8.8,0,0,0,.795.795m7.755-10.8,2.249,2.249L11.259,5.3,9.01,3.048ZM3.178,8.88,7.89,4.168l2.249,2.249L5.427,11.128H3.178ZM15.1,14.306H.795a.795.795,0,0,0,0,1.589H15.1a.795.795,0,1,0,0-1.589",
    transform: "translate(0 0)",
    fill: "#30B524"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1510);
export default __webpack_public_path__ + "static/media/Group1510.a4d80a7e14f0c303957969ffd05644ac.svg";
export { ForwardRef as ReactComponent };